/**
 * Phase 4 — Offer portal (G.12/G.13). Client for the drafted-email endpoints.
 */
export type OfferType = 'dsc' | 'deferral' | 'conviction' | 'appeal';

export interface DraftedEmail {
  subject: string;
  body: string;
  learnMoreUrl: string;
}

function host(): string {
  return process.env.API_HOST?.trim() || window.location.origin;
}

class OfferPortalApi {
  /** G.12 — draft the client offer email (Lloyd's wording + Ken's learn-more link). */
  static async buildOfferEmail(
    ticketGuid: string,
    offerType: OfferType,
    opts?: { deferralDays?: number | null; deferralFeeUsd?: number | null; dscAlsoRequired?: boolean },
  ): Promise<DraftedEmail> {
    const response = await fetch(`${host()}/api/v1/manager/ticket/${ticketGuid}/offer-email`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ offerType, ...opts }),
    });
    if (!response.ok) throw new Error('Failed to build offer email');
    return response.json();
  }

  /** G.13 — draft the court acceptance for staff to review/send. */
  static async buildCourtAcceptance(ticketGuid: string, offerType: OfferType): Promise<DraftedEmail> {
    const response = await fetch(`${host()}/api/v1/manager/ticket/${ticketGuid}/offer-acceptance`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ offerType }),
    });
    if (!response.ok) throw new Error('Failed to build court acceptance draft');
    return response.json();
  }
}

export default OfferPortalApi;
